/**
 * Created by anthony on 6/23/14.
 */
/* Start Auth Service */
var pulsateService = angular.module('pulsateService', []);
pulsateService.factory('PulsateService', function(){

    var pulsate = {};

    var getPulsate = function(field)
    {
        return pulsate[field];
    }

    var setPulsate = function(field)
    {
        pulsate = {};
        pulsate[field] = true;
    }

    return {
        setPulsate: setPulsate,
        getPulsate: getPulsate
    }
});
/* End binService Service */